export const GENDERS = ["male", "female"];

export type Gender = (typeof GENDERS)[number];

export interface FamilyMember
  extends Omit<AddFamilyMemberRequest, "birthdate"> {
  id: number;
  birthdate: string;
}

export interface AddFamilyMemberRequest {
  name: string;
  city: string;
  latitude: number;
  longitude: number;
  timezone: string;
  gender: Gender;
  birthdate: Date;
}
